import styled from "styled-components";

export const JobList = styled.ul`
  padding: 0;
  padding-bottom: 500px;
  list-style: none;
`;

export const JobTitle = styled.h4`
  font-size: 1.6rem;
`;

export const JobContainer = styled.li`
  padding-bottom: 15px;
  @media screen and (max-width: 991px) {
    padding: 0;
    margin: 0;
    border-bottom: 1px solid #efefef;
    width: 100%;
  }
`;

export const Details = styled.ul`
  padding-left: 0;
  list-style: none;
  font-size: 1.2rem;
`;

export const DetailItem = styled.li`
  padding-left: 0;
  list-style: none;
  @media screen and (max-width: 812px) {
    margin-right: 10px;
  }
`;
